import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import LinearProgress from "@material-ui/core/LinearProgress";

import "./Preloader.scss";

const useStyles = makeStyles((theme) => ({
	root: {
		width: "100%",
		maxWidth: "500px",
	},
}));

const Preloader = () => {
	const classes = useStyles();

	return (
		<div className="preloader-container">
			<div className={classes.root}>
				<LinearProgress />
			</div>
		</div>
	);
};

export default Preloader;
